import { useState } from 'react';

import { useError } from '@/hooks/utils/useError';

/**
 * The outcome of a plan section's last autosave, and the mutation callbacks that record it. A
 * failure is reported through the usual error toast and replaces the time of the previous save,
 * which would otherwise keep claiming that the latest changes were saved.
 */
export const useAutosaveStatus = () => {
    const { handleError } = useError();
    const [lastSavedAt, setLastSavedAt] = useState<Date | null>(null);
    const [hasFailed, setHasFailed] = useState(false);

    const saveCallbacks = {
        onSuccess: () => {
            setLastSavedAt(new Date());
            setHasFailed(false);
        },
        onError: (error: Error) => {
            setHasFailed(true);
            handleError({ error });
        },
    };

    return { lastSavedAt, hasFailed, saveCallbacks };
};
